module.exports = __webpack_public_path__ + "static/media/IMG_1640.64bf5209.png";